<template>
<a-spin :spinning="spinning" tip="Loading...">
    <div class="card mb-3">
        <div class="row no-gutters">
            <div class="col-md-12" style="border-right: 1px solid #e0e0e0">
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-7 align-self-center">
                            <div v-if="reportDescription != ''" class="card">
                                <div class="card-body">
                                    <div class="card-text">
                                        {{ reportDescription }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-4">
                            <base-input alternative="" label="From"><br>
                                <a-range-picker v-model="inputDate" :showTime="{ format: 'hh:mm' }" :format="dateFormat" :placeholder="datePickerPlaceholder" style="width:100%"/>
                            </base-input>
                        </div>
                        <div class="col-md-4">
                            <base-input label="Sort By" >
                                <select class="form-control" size="large" v-model="inputSortBy">
                                    <option v-for="option in sortOptions" v-bind:value="option.key" v-bind:key="option.key">
                                        {{ option.value }}
                                    </option>
                                </select>
                            </base-input>
                        </div>
                        <div class="col-md-2 mt-3 pt-3">
                            <button type="button" class="btn btn-sm btn-link" @click='showSortInfoDiv' >
                                {{showSortInfo == 'asc' ? 'Ascending (A-Z) ↡' : 'Descending (Z-A) ↟'}}
                            </button>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-4">
                            <base-input label="Group By" >
                                <select class="form-control" v-model="inputGroupBy">
                                    <option v-for="option in groupOptions" v-bind:value="option.key" v-bind:key="option.key">
                                        {{ option.value }}
                                    </option>
                                </select>
                            </base-input>
                        </div>
                        <div class="col-md-4">
                            <base-input label="Filtered By" >
                                <select class="form-control" v-model="inputFilterBy">
                                    <option v-for="option in filterOptions" v-bind:value="option.key" v-bind:key="option.key">
                                        {{ option.value }}
                                    </option>
                                </select>
                            </base-input>
                        </div>
                        <div class="col-md-4">
                            <base-input alternative="" label="Select Site">
                                <a-select mode="multiple" v-model="inputSite" showSearch placeholder="All Sites" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" :disabled="site_type != 'ho'">
                                    <a-select-option v-for="option in siteOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                </a-select>
                            </base-input>
                        </div>
                    </div>


                    <div class="row">
                        <div class="col-md-12">
                            <br>
                            <button v-if="jsonData.length < 1" class="btn btn-sm btn-default float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="excelData">Generate Report in Excel</button>
                            <button v-if="jsonData.length > 0" class="btn btn-sm btn-success float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="generateExcel"> Download excel </button> &nbsp; &nbsp;
                            <button class="btn btn-sm btn-default float-right"
                                    style="border-radius: 24px; border:0px; width: 20%;"
                                    @click.prevent="generateReport">
                                Generate Report in PDF
                            </button> &nbsp; &nbsp;
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</a-spin>
</template>

<script>
    import HTTPRequest from '../../controllers/httpRequest.js'
    import secureStorage from '../../controllers/secureStorage';
    import moment from 'moment';
    import jsPDF from 'jspdf';
    import 'jspdf-autotable';
    import { getReportDescription } from '../../utilities';
    import * as ExcelJS from "exceljs";
    import { saveAs } from "file-saver";

    import {
        mapState
    } from 'vuex'

    export default {
        data() {
            return {
                spinning: false,
                inputSortBy: 'terminal_name',
                inputGroupBy: '',
                inputFilterBy: 2,
                inputSite: [],
                site_type: "ho",
                inputDate: [moment().startOf('day'), moment().endOf('day')],
                sortOptions: [
                    {key: 'terminal_name', value: 'Terminal'},
                    {key: 'document_date', value: 'Date Time'}
                ],
                groupOptions: [
                    {key: '', value: '[Flat List]'},
                    {key: 'terminal_id', value: 'Terminal'},
                    {key: 'customer_id', value: 'Customer'}
                ],
                filterOptions: [
                    {key: 0, value: '[All Members]'},
                    {key: 1, value: '[Non-Members]'},
                    {key: 2, value: '[All Customers]'}
                ],
                siteOptions: [],
                dateFormat: 'MM/DD/YYYY hh:mm A',
                datePickerPlaceholder: ['Start', 'End'],
                birSalesReports: [],

                showSortInfo: 'asc',
                excelFileName: "sc_sales_reports",
                reportDescription: '',
                jsonData: [],
                excelIsNonVatable: false,
            }
        },
        mounted: async function () {
            var component_x = this;

            var userId = secureStorage.getItem("userId")
            var sites = await HTTPRequest.getRequest(component_x.endPoint + "sites/get_valid_sites?user_id=" + userId, null);
            component_x.siteOptions = sites;
            component_x.sort(component_x.siteOptions);

            let siteId = secureStorage.getItem("defaultSiteId")
            this.inputSite = [siteId]
            this.reportDescription = await getReportDescription(this.currentProfile)

            let site = await HTTPRequest.getRequest(component_x.endPoint + "/sites/" + siteId, null)
            if(site != undefined){
                component_x.site_type = site.site_type
            }
        },
        computed: {
            ...mapState(['currentProfile', 'currentApiURL', 'endPoint', 'parameters']),
        },
        methods: {
            moment,
            filterOption(input, option) {
                return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
            },
            sort(data){
                data.sort(function (a, b) {
                    return a.name.localeCompare(b.name);
                });
            },
            // Advanced Info
            showSortInfoDiv(){
                this.showSortInfo == 'asc' ? this.showSortInfo = 'desc' : this.showSortInfo = 'asc'
            },
            reportNumber(value){
                const number = Number(value)
                return isNaN(number) ? 0 : number
            },
            reportText(value){
                return value === undefined || value === null ? '' : String(value)
            },
            reportDate(value){
                const date = moment(value)
                return value && date.isValid() ? date.format('MM/DD/YYYY hh:mm a') : ''
            },
            excelText(value){
                const text = this.reportText(value)
                return text == '' ? '' : "'" + text
            },
            convertToCurrency(num){
                return this.reportNumber(num).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
            },
            convertToCurrencyForExcel(num){
                return this.reportNumber(num).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
            },
            isNonVatableReport(reportDetails){
                if(Array.isArray(reportDetails)){
                    return reportDetails.length > 0 && this.reportText(reportDetails[0].company_vat_type) == 'N'
                }
                return reportDetails && this.reportText(reportDetails.company_vat_type) == 'N'
            },
            isNonVatableSiteReports(siteReports){
                const siteReport = Array.isArray(siteReports) ? siteReports.find(report => Array.isArray(report.report_details) && report.report_details.length > 0) : null
                return siteReport ? this.isNonVatableReport(siteReport.report_details) : false
            },
            salesHeaderLabel(reportDetails){
                return this.isNonVatableReport(reportDetails) ? 'Sales' : 'Sales (inclusive of VAT)'
            },
            reportHeaders(reportDetails){
                const headers = [
                    {content: 'DateTime', rowSpan: 1, styles: {halign: 'center'}},
                    {content: 'Customer Name', rowSpan: 1, styles: {halign: 'center'}},
                    {content: 'OSCA #', rowSpan: 1, styles: {halign: 'center'}},
                    {content: 'TIN', rowSpan: 1, styles: {halign: 'center'}},
                    {content: 'SI#', rowSpan: 1, styles: {halign: 'center'}},
                    {content: this.salesHeaderLabel(reportDetails), colSpan: 1, rowSpan: 1, styles: {halign: 'center'}}
                ]
                if(!this.isNonVatableReport(reportDetails)){
                    headers.push(
                        {content: 'VAT Amount', rowSpan: 1, styles: {halign: 'center'}},
                        {content: 'VAT Exempt', rowSpan: 1, styles: {halign: 'center'}}
                    )
                }
                headers.push(
                    {content: 'Discount 5%', rowSpan: 1, styles: {halign: 'center'}},
                    {content: 'Discount 20%', rowSpan: 1, styles: {halign: 'center'}},
                    {content: 'Net Sales', rowSpan: 1, styles: {halign: 'center'}}
                )
                return headers
            },
            salesValues(reportLine, reportDetails){
                const values = [this.convertToCurrency(reportLine.sales_vat_inclusive)]
                if(!this.isNonVatableReport(reportDetails)){
                    values.push(
                        this.convertToCurrency(reportLine.vat_amount),
                        this.convertToCurrency(reportLine.vat_exempt_sales)
                    )
                }
                return values
            },
            salesValuesForExcel(reportLine, reportDetails){
                const values = [this.convertToCurrencyForExcel(reportLine.sales_vat_inclusive)]
                if(!this.isNonVatableReport(reportDetails)){
                    values.push(
                        this.convertToCurrencyForExcel(reportLine.vat_amount),
                        this.convertToCurrencyForExcel(reportLine.vat_exempt_sales)
                    )
                }
                return values
            },
            totalSalesValues(totalSales, totalVat, totalVatEx, reportDetails){
                const values = [this.convertToCurrency(totalSales)]
                if(!this.isNonVatableReport(reportDetails)){
                    values.push(this.convertToCurrency(totalVat), this.convertToCurrency(totalVatEx))
                }
                return values
            },
            totalSalesValuesForExcel(totalSales, totalVat, totalVatEx, reportDetails){
                const values = [this.convertToCurrencyForExcel(totalSales)]
                if(!this.isNonVatableReport(reportDetails)){
                    values.push(this.convertToCurrencyForExcel(totalVat), this.convertToCurrencyForExcel(totalVatEx))
                }
                return values
            },
            reportColumnStyles(reportDetails){
                const styles = {
                    0: {cellWidth: 'auto', halign: 'left'},
                    1: {cellWidth: 'auto', halign: 'left'},
                    2: {cellWidth: 'auto', halign: 'left'},
                    3: {cellWidth: 'auto', halign: 'left'},
                    4: {cellWidth: 'auto', halign: 'left'}
                }
                const lastIndex = this.isNonVatableReport(reportDetails) ? 8 : 10
                for(let index = 5; index <= lastIndex; index++){
                    styles[index] = {cellWidth: 'auto'}
                }
                return styles
            },
            excelHeadersForReport(reportDetails){
                const headers = ['Date Time', 'Customer Name', 'OSCA #', 'TIN', 'SI#', this.salesHeaderLabel(reportDetails)]
                if(!this.isNonVatableReport(reportDetails)){
                    headers.push('VAT Amount', 'VAT Exempt')
                }
                headers.push('Discount 5%', 'Discount 20%', 'Net Sales')
                return headers
            },
            hasReportDetails(reportDetails){
                if(!Array.isArray(reportDetails)){
                    return false
                }

                const textFields = [
                    'invoice_no', 'document_date', 'customer_name', 'customer_tin',
                    'osca_number', 'terminal_code', 'serial_no'
                ]
                const amountFields = [
                    'sales_vat_inclusive', 'vat_amount', 'vat_exempt_sales', 'discount',
                    'net_sales', 'sc_5_discount', 'sc_20_discount', 'total_sc_discount'
                ]

                return reportDetails.some(detail => {
                    if(!detail){
                        return false
                    }

                    const hasTextValue = textFields.some(field => this.reportText(detail[field]).trim() != '')
                    const hasAmountValue = amountFields.some(field => this.reportNumber(detail[field]) != 0)

                    return hasTextValue || hasAmountValue
                })
            },
            filteredSiteReports(siteReports){
                if(!Array.isArray(siteReports)){
                    return []
                }

                return siteReports.filter(siteReport => siteReport && this.hasReportDetails(siteReport.report_details))
            },
            openNotificationWithIcon(type, msg) {
                if(type == 'error'){
                    this.$notification[type]({
                        message: 'Export Error',
                        description: msg
                    });
                }else if(type == 'warning'){
                    this.$notification[type]({
                        message: 'No Data Found',
                        description: msg
                    });
                }
            },
            generateReport: async function () {
                this.spinning= true;
                var get_request = {}

                if(this.inputDate.length == 0){
                    this.openNotificationWithIcon('error', 'Please make sure to check your current filters.');
                    this.spinning= false;
                    return
                }

                get_request = await HTTPRequest.getRequest(this.endPoint + 'pos_documents/sc_5_1_sales?site_id=' + this.inputSite +
                        '&date_from=' + this.inputDate[0].format('YYYY-MM-DD HH:mm:ss') + '&date_to=' + this.inputDate[1].format('YYYY-MM-DD HH:mm:ss') +
                        '&order=' + this.inputSortBy + '&by=' + this.showSortInfo + '&group=' + this.inputGroupBy + '&filter=' + this.inputFilterBy, null)
                if(get_request.error) {
                    this.openNotificationWithIcon('error', get_request.error);
                    this.spinning= false;
                    return
                }
                var siteSpecific = this.filteredSiteReports(get_request);

                if(siteSpecific.length > 0){
                    var doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'a2' });

                    // let reportLogo = document.getElementById('reportLogo');
                    // doc.addImage(reportLogo, "PNG", 30, 0, 30, 15);

                    var headers = [];

                    let g_total_sales = 0
                    let g_total_vat = 0
                    let g_total_vat_ex = 0
                    let g_total_5_discount = 0
                    let g_total_20_discount = 0
                    let g_total_net = 0

                    for(var x=0; x < siteSpecific.length; x++){
                        this.birSalesReports = siteSpecific[x].report_details

                        if(x > 0 && this.birSalesReports.length > 0){
                            doc.addPage();
                        }

                        if(this.birSalesReports.length > 0){
                            let total_total_sales = 0
                            let total_total_vat = 0
                            let total_total_vat_ex = 0
                            let total_total_5_discount = 0
                            let total_total_20_discount = 0
                            let total_total_net = 0

                            let site_total_sales = 0
                            let site_total_vat = 0
                            let site_total_vat_ex = 0
                            let site_total_5_discount = 0
                            let site_total_20_discount = 0
                            let site_total_net = 0

                            var reportData = [];

                            let grouper = '';
                            let grouper_text = '';

                            for(var i=0; i < this.birSalesReports.length; i++){
                                let reportLine = this.birSalesReports[i]

                                if(this.inputGroupBy == 'terminal_id'){
                                    if(grouper == ''){
                                        let detail_header = ["Terminal :", this.reportText(reportLine.terminal_code)]
                                        reportData.push(Object.assign({}, detail_header))
                                    } else {
                                        if(grouper != reportLine.terminal_id){
                                            let detail_header = ['Terminal :', this.reportText(reportLine.terminal_code)];
                                            reportData.push(Object.assign({}, detail_header))
                                        }
                                    }
                                    grouper = reportLine.terminal_id
                                }else if(this.inputGroupBy == 'customer_id'){
                                    if(grouper == '' && grouper_text == ''){
                                        let detail_header = ["Customer :", this.reportText(reportLine.customer_name)]
                                        reportData.push(Object.assign({}, detail_header))

                                    } else {
                                    if(grouper != reportLine.customer_id){
                                            let detail_header = ['Customer :', this.reportText(reportLine.customer_name)];
                                            reportData.push(Object.assign({}, detail_header))
                                        } else {
                                            if(reportLine.customer_id == 0){
                                                let current_grouper = reportLine.customer_name
                                                let prev_grouper = this.birSalesReports[i-1].customer_name
                                                if(current_grouper != prev_grouper){
                                                    let detail_header = ['Customer :', this.reportText(reportLine.customer_name)];
                                                    reportData.push(Object.assign({}, detail_header))
                                                }
                                            }
                                        }
                                    }

                                    grouper = reportLine.customer_id
                                    grouper_text = reportLine.customer_name
                                }


                                var detail = [
                                    this.reportDate(reportLine.document_date),
                                    this.reportText(reportLine.customer_name), this.reportText(reportLine.osca_number), this.reportText(reportLine.customer_tin),
                                    this.reportText(reportLine.invoice_no)
                                ].concat(
                                    this.salesValues(reportLine, this.birSalesReports),
                                    [
                                        this.convertToCurrency(reportLine.sc_5_discount),
                                        this.convertToCurrency(reportLine.sc_20_discount),
                                        this.convertToCurrency(reportLine.net_sales)
                                    ]
                                )


                                reportData.push(Object.assign({}, detail))

                                total_total_sales += this.reportNumber(reportLine.sales_vat_inclusive),
                                total_total_vat += this.reportNumber(reportLine.vat_amount),
                                total_total_vat_ex += this.reportNumber(reportLine.vat_exempt_sales),
                                total_total_5_discount += this.reportNumber(reportLine.sc_5_discount),
                                total_total_20_discount += this.reportNumber(reportLine.sc_20_discount),
                                total_total_net += this.reportNumber(reportLine.net_sales)

                                site_total_sales += this.reportNumber(reportLine.sales_vat_inclusive),
                                site_total_vat += this.reportNumber(reportLine.vat_amount),
                                site_total_vat_ex += this.reportNumber(reportLine.vat_exempt_sales),
                                site_total_5_discount += this.reportNumber(reportLine.sc_5_discount),
                                site_total_20_discount += this.reportNumber(reportLine.sc_20_discount),
                                site_total_net += this.reportNumber(reportLine.net_sales)



                                if(i == this.birSalesReports.length-1){
                                    if(this.inputGroupBy != ''){
                                        let total = [
                                            '', '', '', '',
                                            "Total :"
                                        ].concat(
                                            this.totalSalesValues(total_total_sales, total_total_vat, total_total_vat_ex, this.birSalesReports),
                                            [
                                                this.convertToCurrency(total_total_5_discount),
                                                this.convertToCurrency(total_total_20_discount),
                                                this.convertToCurrency(total_total_net)
                                            ]
                                        )
                                        reportData.push(Object.assign({}, ["rowLine"]))
                                        reportData.push(Object.assign({}, total))
                                    }

                                    let site_total = [
                                        '', '', '', '',
                                        "Site Total :"
                                    ].concat(
                                        this.totalSalesValues(site_total_sales, site_total_vat, site_total_vat_ex, this.birSalesReports),
                                        [
                                            this.convertToCurrency(site_total_5_discount),
                                            this.convertToCurrency(site_total_20_discount),
                                            this.convertToCurrency(site_total_net)
                                        ]
                                    )
                                    reportData.push(Object.assign({}, ["rowLine"]))
                                    reportData.push(Object.assign({}, site_total))
                                } else {
                                    let current_grouper = ""
                                    let next_grouper = ""

                                    if(this.inputGroupBy == 'terminal_id'){
                                        current_grouper = reportLine.terminal_id
                                        next_grouper = this.birSalesReports[i+1].terminal_id
                                    } else if(this.inputGroupBy == 'customer_id'){
                                        if(reportLine.customer_id == 0){
                                            current_grouper = reportLine.customer_name
                                            next_grouper = this.birSalesReports[i+1].customer_name
                                        } else {
                                            current_grouper = reportLine.customer_id
                                            next_grouper = this.birSalesReports[i+1].customer_id
                                        }
                                    }

                                    if(current_grouper != next_grouper){
                                        if(this.inputGroupBy != ''){
                                            let total = [
                                            '', '', '', '',
                                            "Total :"
                                        ].concat(
                                            this.totalSalesValues(total_total_sales, total_total_vat, total_total_vat_ex, this.birSalesReports),
                                            [
                                                this.convertToCurrency(total_total_5_discount),
                                                this.convertToCurrency(total_total_20_discount),
                                                this.convertToCurrency(total_total_net)
                                            ]
                                        )
                                            reportData.push(Object.assign({}, ["rowLine"]))
                                            reportData.push(Object.assign({}, total))

                                            total_total_sales = 0
                                            total_total_vat = 0
                                            total_total_vat_ex = 0
                                            total_total_5_discount = 0
                                            total_total_20_discount = 0
                                            total_total_net = 0
                                        }
                                    }
                                }
                            }

                            g_total_sales += site_total_sales
                            g_total_vat += site_total_vat
                            g_total_vat_ex += site_total_vat_ex
                            g_total_5_discount += site_total_5_discount
                            g_total_20_discount += site_total_20_discount
                            g_total_net += site_total_net

                            if(x == siteSpecific.length-1){
                                let grand_total = [
                                    '', '', '', '',
                                    "Grand Total :"
                                ].concat(
                                    this.totalSalesValues(g_total_sales, g_total_vat, g_total_vat_ex, this.birSalesReports),
                                    [
                                        this.convertToCurrency(g_total_5_discount),
                                        this.convertToCurrency(g_total_20_discount),
                                        this.convertToCurrency(g_total_net)
                                    ]
                                )
                                reportData.push(Object.assign({}, ["rowLine"]))
                                reportData.push(Object.assign({}, grand_total))
                            }
                        }

                        doc.setFontSize(16);
                        doc.setFontType("bold");

                        let grouper_name = ""
                        if(this.inputGroupBy == 'customer_id'){
                            grouper_name = " BY CUSTOMER"
                        } else if (this.inputGroupBy == "terminal_id"){
                            grouper_name = " BY TERMINAL"
                        } else if (this.inputGroupBy == "user_id"){
                            grouper_name = " BY CASHIER"
                        }
                        var pageWidth = doc.internal.pageSize.getWidth()/2;

                        doc.text(pageWidth,20,"Senior Citizen Sales Book" + grouper_name, { align: 'center' })
                        doc.text(pageWidth,27, this.reportText(siteSpecific[x].report_details[0].site_name), { align: 'center' })
                        doc.text(pageWidth,34, this.reportText(siteSpecific[x].report_details[0].site_address), { align: 'center' })
                        doc.text(pageWidth,41, this.reportText(siteSpecific[x].report_details[0].site_tin), { align: 'center' })

                        doc.setFontSize(12);
                        doc.setFontType("normal");

                        doc.text(30,58,"Software")
                        doc.text(95,58, ": barter RPOS 5.1")
                        doc.text(30,65,"Serial Number")
                        doc.text(95,65,": " + this.reportText(siteSpecific[x].report_details[0].serial_no))
                        doc.text(30,72,"Machine Identification Number")
                        doc.text(95,72,": " + this.reportText(siteSpecific[x].report_details[0].machine_number))
                        doc.text(30,79,"POS Terminal")
                        doc.text(95,79,": " + this.reportText(siteSpecific[x].report_details[0].terminal_code))
                        doc.text(30,86,"Business Day Period")
                        doc.text(95,86,": From " + this.inputDate[0].format('MMM D, YYYY h:mm A')  + " to " + this.inputDate[1].format('MMM D, YYYY h:mm A'))

                        headers = [this.reportHeaders(this.birSalesReports)];
                        doc.autoTable({
                            startY: 100,
                            head: headers,
                            body: reportData,
                            theme: 'plain',
                            tableWidth: 'auto',
                            headStyles: {
                                lineWidth: 0.15,
                                cellPadding: 3
                            },
                            styles: {
                                cellPadding: 3, fontSize: 14,
                                halign: 'right'
                            },
                            margin: { left: 30, right: 30},
                            columnStyles: this.reportColumnStyles(this.birSalesReports),
                            didParseCell: function(data) {
                                if (data.row.section == 'body' && data.row.raw[0] == 'rowLine'){
                                    data.cell.styles.fillColor = [0, 0, 0]
                                    data.cell.styles.fontSize = 1
                                    data.cell.styles.cellPadding = 0
                                } else if (data.row.section == 'body' && Object.values(data.row.raw).some(value => value == 'Total :' || value == 'Site Total :' || value == 'Grand Total :')){
                                    data.cell.styles.fontStyle = 'bold'
                                }
                            },
                        });

                        let footer = ""
                        if(this.inputGroupBy == 'customer_id'){
                            footer = " by Customer"
                        } else if (this.inputGroupBy == "terminal_id"){
                            footer = " by Terminal"
                        } else if (this.inputGroupBy == "user_id"){
                            footer = " by Cashier"
                        }

                        doc.text(30,400,"Printed By: " + secureStorage.getItem("email"))

                            doc.text(580,400,"SC Sales Report" + footer, "right")

                        doc.text(30,405,"Print Date: " + moment().format(this.dateFormat))
                        doc.text(580,405,"Page " + ( x + 1)  + " of " + siteSpecific.length, "right")
                    }
                        //doc.save(`sc_Sales_Report_${moment().format('YYYYMMDDHHmmss')}.pdf`);
                        window.open(URL.createObjectURL(doc.output("blob")))
                } else {
                    this.openNotificationWithIcon('warning', 'Try increasing the scope by adjusting the filters.');
                }
                this.spinning= false;
            },
             excelData: async function() {
              this.spinning= true;
              var jsonData = [];
              let request = {};
              let total_sales = 0
              let total_vat = 0
              let total_vat_ex = 0
              let total_5_discount = 0
              let total_20_discount = 0
              let total_net = 0
              let site_specific = []

                if(this.inputDate.length == 0){
                    this.openNotificationWithIcon('error', 'Please make sure to check your current filters.');
                    this.spinning= false;
                    return
                }

                request = await HTTPRequest.getRequest(this.endPoint + 'pos_documents/sc_5_1_sales?site_id=' + this.inputSite +
                        '&date_from=' + this.inputDate[0].format('YYYY-MM-DD HH:mm:ss') + '&date_to=' + this.inputDate[1].format('YYYY-MM-DD HH:mm:ss') +
                        '&order=' + this.inputSortBy + '&by=' + this.showSortInfo + '&group=' + this.inputGroupBy + '&filter=' + this.inputFilterBy, null)

                if (!request[0]) {
                    this.openNotificationWithIcon('warning', 'Try increasing the scope by adjusting the filters.');
                    this.spinning= false;
                    return;
                }
                var siteSpecific = this.filteredSiteReports(request);

                if (siteSpecific.length < 1) {
                    this.openNotificationWithIcon('warning', 'Try increasing the scope by adjusting the filters.');
                    this.spinning= false;
                    return;
                }

                var header_details = [
                    "","","","Senior Citizen Sales Book",
                    "","","","","",""
                    ]
                jsonData.push(header_details)
                this.excelIsNonVatable = this.isNonVatableSiteReports(siteSpecific)
                const excelReportDetails = {company_vat_type: this.excelIsNonVatable ? 'N' : 'V'}
                var header = this.excelHeadersForReport(excelReportDetails)


                for(var x=0; x < siteSpecific.length; x++){
                    var reportDetails = siteSpecific[x].report_details;
                    jsonData.push([
                    "","","",this.reportText(reportDetails[0].site_name),
                    "","","","","",""
                    ])
                    jsonData.push([
                    "","","",this.reportText(reportDetails[0].site_address),
                    "","","","","",""
                    ])
                    jsonData.push([
                    "","","",this.reportText(reportDetails[0].site_tin),
                    "","","","","",""
                    ])
                    jsonData.push([
                    "Software ","",": barter RPOS 5.1","","",
                    "","","","",""
                    ])
                    jsonData.push([
                    "Serial Number","",": "+this.reportText(reportDetails[0].serial_no),"","",
                    "","","","",""
                    ])
                    jsonData.push([
                    "Machine Identification Number","",": "+this.reportText(reportDetails[0].machine_number),"","",
                    "","","","",""
                    ])
                    jsonData.push([
                    "POS Terminal","",": "+this.reportText(reportDetails[0].terminal_code),"","",
                    "","","","",""
                    ])
                    jsonData.push([
                    "Business Day Period","",": From " + this.inputDate[0].format('MMM D, YYYY h:mm A'),"to " + this.inputDate[1].format('MMM D, YYYY h:mm A'),"",
                    "","","","",""
                    ])

                    jsonData.push([])
                    jsonData.push(header)
                    reportDetails.map(detail => {
                        let details = []
                        total_net += this.reportNumber(detail.net_sales)
                        total_sales += this.reportNumber(detail.sales_vat_inclusive)
                        total_vat += this.reportNumber(detail.vat_amount)
                        total_vat_ex += this.reportNumber(detail.vat_exempt_sales)
                        total_5_discount += this.reportNumber(detail.sc_5_discount)
                        total_20_discount += this.reportNumber(detail.sc_20_discount)
                        details = [
                            this.reportDate(detail.document_date),
                            this.reportText(detail.customer_name), this.reportText(detail.osca_number), this.reportText(detail.customer_tin),
                            this.excelText(detail.invoice_no)
                        ].concat(
                            this.salesValuesForExcel(detail, reportDetails),
                            [
                                this.convertToCurrencyForExcel(detail.sc_5_discount),
                                this.convertToCurrencyForExcel(detail.sc_20_discount),
                                this.convertToCurrencyForExcel(detail.net_sales)
                            ]
                        )
                        jsonData.push(details)
                    })


                    var footer = [
                        '',
                        '',
                        '',
                        '',
                        'Grand Total:'
                    ].concat(
                        this.totalSalesValuesForExcel(total_sales, total_vat, total_vat_ex, reportDetails),
                        [
                            this.convertToCurrencyForExcel(Number(total_5_discount)),
                            this.convertToCurrencyForExcel(Number(total_20_discount)),
                            this.convertToCurrencyForExcel(Number(total_net))
                        ]
                    )
                    jsonData.push(footer)

                    let keys = header;
                    let values = jsonData;
                    var values_length = values.length;

                    let newJsonData=[];

                    // change headers and report data as key and value object
                    for(var i=0;i < values_length; i++){
                        var result =  Object.assign.apply({}, keys.map( (val, index) => ( {
                                    [val]: values[i][index]
                                }
                            )
                        )
                        );
                        newJsonData.push(result)
                    }

                    // change undefined on arr
                    newJsonData.forEach(function(obj) {
                        for(var i in obj) {
                        if(obj[i] === undefined || obj[i] === null ) {
                            obj[i] = '';
                        }
                        }
                    });
                    site_specific.push(newJsonData)
                }
                this.spinning= false;
                this.jsonData = site_specific.flat(Infinity)
            },
            async generateExcel(){
                const workbook = new ExcelJS.Workbook();
                workbook.created = new Date();
                workbook.modified = new Date();
                const sheet = workbook.addWorksheet("sc Sales Reports", {
                    pageSetup:{paperSize: 1}
                });

                const data_starts_at_row = 11

                //custom header
                var report_details = this.jsonData
                sheet.getRow(1).values = Object.values(report_details[0])
                sheet.getRow(1).font = { bold: true };
                sheet.getRow(2).values = Object.values(report_details[1])
                sheet.getRow(2).font = { bold: true };
                sheet.getRow(3).values = Object.values(report_details[2])
                sheet.getRow(3).font = { bold: true };
                sheet.getRow(4).values = Object.values(report_details[3])
                sheet.getRow(4).font = { bold: true };
                sheet.getRow(5).values = Object.values(report_details[4])
                sheet.getRow(6).values = Object.values(report_details[5])
                sheet.getRow(7).values = Object.values(report_details[6])
                sheet.getRow(8).values = Object.values(report_details[7])
                sheet.getRow(9).values = Object.values(report_details[8])
                sheet.getRow(10).values = Object.values(report_details[9])
                sheet.getRow(data_starts_at_row).values = this.excelHeadersForReport({company_vat_type: this.excelIsNonVatable ? 'N' : 'V'});

                            sheet.columns = this.excelIsNonVatable ? [
                            { key: "created_at", width: 20 },
                            { key: "customer_name" , width: 20 },
                            { key: "osca_no" , width: 30 },
                            { key: "tin" , width: 30 },
                            { key: "si_no" , width: 30 },
                            { key: "sales", width: 15 },
                            { key: "discount_5", width: 10 },
                            { key: "discount_20", width: 10 },
                            { key: "net_sales", width: 10 }
                        ] : [
                            { key: "created_at", width: 20 },
                            { key: "customer_name" , width: 20 },
                            { key: "osca_no" , width: 30 },
                            { key: "tin" , width: 30 },
                            { key: "si_no" , width: 30 },
                            { key: "sales", width: 15 },
                            { key: "vat_amount", width: 10 },
                            { key: "vat_ex", width: 10 },
                            { key: "discount_5", width: 10 },
                            { key: "discount_20", width: 10 },
                            { key: "net_sales", width: 10 }
                        ];

                // var report_details = get_request[0].report_details
                // console.log("details", report_details)
                var rowDatas = []
                for(let i = 0; i < report_details.length; i++){
                    if (i >= 11){
                        const report_detail = report_details[i]
                        const parseNum = (val) => Number(String(val || '').replace(/,/g, '')) || 0
                        var rowData = {created_at: report_detail["Date Time"],customer_name: report_detail["Customer Name"],
                            osca_no: report_detail["OSCA #"],tin: report_detail["TIN"],
                            si_no: report_detail["SI#"],
                            sales: parseNum(report_detail[this.excelIsNonVatable ? "Sales" : "Sales (inclusive of VAT)"]),
                            discount_5: parseNum(report_detail["Discount 5%"]),
                            discount_20: parseNum(report_detail["Discount 20%"]),
                            net_sales: parseNum(report_detail["Net Sales"])
                        }
                        if(!this.excelIsNonVatable){
                            rowData.vat_amount = parseNum(report_detail["VAT Amount"])
                            rowData.vat_ex = parseNum(report_detail["VAT Exempt"])
                        }
                        rowDatas.push(rowData)
                    }

                }
                sheet.addRows(rowDatas);

                //styles
                // sheet.getRow(4).font = { bold: true, size: 16 };
                // sheet.getRow(4).height = 20;
                // sheet.getRow(7).font = { bold: true };
                sheet.getRow(data_starts_at_row).font = { bold: true };

                // Apply number format to amount columns
                const amountNumFmt = '#,##0.00'
                const amountStartCol = 6 // sales column
                sheet.eachRow(function (Row, rowNum) {
                    if(rowNum > data_starts_at_row){
                        Row.eachCell(function (Cell, colNumber) {
                            if(colNumber >= amountStartCol){
                                Cell.numFmt = amountNumFmt
                            }
                            Cell.alignment = {
                                vertical: 'middle',
                                horizontal: 'left'
                            }
                        })
                    } else if(rowNum == data_starts_at_row){
                        Row.eachCell(function (Cell) {
                            Cell.alignment = {
                                horizontal: 'center'
                            }
                        })
                    }
                })

                workbook.xlsx.writeBuffer().then(function(buffer) {
                    const blob = new Blob([buffer], { type: "applicationi/xlsx" });
                    saveAs(blob, `sc_sales_report.xlsx`);
                });
                this.jsonData = []
            },
        }
    };
</script>

<style></style>
